<template>
  <v-dialog v-model="show" max-width="800px" max persistent scrollable>
    <v-card class="fill-height">
      <validation-observer ref="form" v-slot="observer" >
      <v-card-text v-if="formValues">
        <v-card-title mt-2 style="justify-content: center;">{{ modalTitle }}</v-card-title>
          <v-form>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" :name="$t('settings.alerts.name')" rules="required">
                <v-text-field
                  v-model="formValues.name"
                  :error-messages="errors"
                  :label="$t('settings.alerts.name')"
                  clearable
                  required
                >
                </v-text-field>
              </validation-provider>
              <v-switch
                v-model="formValues.activate"
                :label="$t('settings.active')"
              />
              <validation-provider v-slot="{ errors }" :name="$t('settings.alerts.triggeringStatus')" rules="required">
                <v-select
                  v-model="formValues.onStatus"
                  :items="triggeringStatus"
                  :label="$t('settings.alerts.triggeringStatus')"
                  class="mt-4"
                  clearable
                  multiple
                  :error-messages="errors"
                ></v-select>
              </validation-provider>
              <validation-provider
                v-if="formValues.type === 'email'"
                rules="required|emailList"
                :name="$t('settings.alerts.emails')"
                v-slot="{ errors }"
              >
                <v-combobox
                  v-model="formValues.emails"
                  :label="$t('settings.alerts.emails')"
                  multiple
                  clearable
                  :error-messages="errors"
                  class="no-dropdown-chevron"
                />
              </validation-provider>
              <validation-provider
                rules="required"
                :name="$t('settings.alerts.template')"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="formValues.templateId"
                  :items="templateIds"
                  item-text="name"
                  item-value="id"
                  :disabled="templateIds.length < 2"
                  :label="$t('settings.alerts.template')"
                  clearable
                  :error-messages="errors"
                ></v-select>
              </validation-provider>
            </v-col>
          </v-form>
      </v-card-text>
      <v-card-actions class="pa-0 mt-2">
        <v-btn
          color="primary"
          style="width: 50%"
          tile
          @click="onSubmit"
          :disabled="observer.invalid"
        >
          {{ $t('settings.alerts.validate') }}
        </v-btn>
        <v-btn
          class="ml-0"
          color="secondary"
          style="width: 50%"
          tile
          @click="close"
        >
          {{ $t('settings.alerts.cancel') }}
        </v-btn>
      </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { displayMessage } from "@/helpers/helper"


export default {
  name: 'AlertFormDialog',
  props: {
    formValue: {
      type: Object,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    unavailableTriggeringStatus: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data () {
    return {
      formValues: null,
      templateIds: [
        { id: "oms-order-status-alert", name: this.$t('settings.alerts.defaultTemplateName') }
      ]
    }
  },
  mounted () {
    if(this.formValue) {
      this.formValues = JSON.parse(JSON.stringify(this.formValue))
    } else {
      this.formValues = {
        name: undefined,
        activate: false,
        type: "email",
        onStatus: [],
        emails: [],
        templateId: this.templateIds[0].id
      }
    }

  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    triggeringStatus () {

      const allTriggeringStatus = [
        { text: this.$t('settings.alerts.nonCompliant'), value: 'blocked' },
        { text: this.$t('settings.alerts.errorOrders'), value: 'error' }
      ]
      let availableStatus = allTriggeringStatus.filter(triggerStatus => {
        return !this.unavailableTriggeringStatus.includes(triggerStatus.value)
      })
      const initiallySelectedStatus = this.formValue?.onStatus || []
      for(let status of initiallySelectedStatus) {
        const matchingCompleteStatus = allTriggeringStatus.find(triggerStatus => triggerStatus.value === status)
        if(matchingCompleteStatus) {
          availableStatus.push(matchingCompleteStatus)
        }
      }
      return availableStatus
    },
    modalTitle() {
      return this.formValue ? this.$t('settings.alerts.editAlert') : this.$t('settings.alerts.addAlert')
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async onSubmit () {
      const success = await this.$refs.form.validate()
      if (success) {
        this.$emit('validateForm', this.formValues)
      } else {
        displayMessage(this.$t('settings.invalidSettings'))
      }
    }
  }
}
</script>

<style scoped>
  .no-dropdown-chevron ::v-deep(.v-input__icon--append) {
    display: none;
  }

</style>

